const venturaCities = [
    "Oxnard", "Thousand Oaks", "Simi Valley", "Ventura (San Buenaventura)", "Camarillo", "Moorpark", "Santa Paula", "Port Hueneme", "Fillmore", "Oak Park", "Ojai", "El Rio", "Mira Monte", "Oak View", "Meiners Oaks", "Santa Rosa Valley", "Casa Conejo", "Channel Islands Beach", "Piru", "Bell Canyon", "Lake Sherwood", "Somis", "Santa Susana", "Saticoy"
];

export default venturaCities;
